import React, { useState } from "react";
import { Switch, FormControlLabel } from "@material-ui/core";

const ToggleProfile = ({
  productProfile = "lite",  // Default profile is 'lite'
  productName,
  deploymentType,            // Deployment type from AddProductSection
  onProfileChange,          // Callback for when profile is changed
}: {
  productProfile: string;
  productName: string;
  deploymentType: string;
  onProfileChange: (newProfile: string) => void;
}) => {
  const [profile, setProfile] = useState(productProfile);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newProfile = event.target.checked ? "ha" : "lite";
    setProfile(newProfile);
    onProfileChange(newProfile);  // Pass the new profile to the parent
  };

  return (
    <>
      {deploymentType === "lite" && (
        <FormControlLabel
          control={
            <Switch
              checked={profile === "ha"}
              onChange={handleToggle}
              name="profileToggle"
            />
          }
          label={profile === "lite" ? "Lite" : "HA"}
        />
      )}
    </>
  );
};

export default ToggleProfile;
